/** Mirrors the NOTIFTYPE_* constants of com.bobex.model.NotificationModel. */
export enum NotificationTypeEnum {
    NEW = 1,
    MONTHLY_CAPPING = 2,
    CATEG_CAPPING = 3,
    BLOCK = 4,
    HOLIDAYS_START = 5,
    HOLIDAYS_END = 6,
    GLOBAL_CAPPING_ZERO = 7,
    CATEG_CAPPING_ZERO = 8,
    INVOICE_UNPAID = 9,
    MAILINGPLANNING_NEW = 10,
    INVOICE_UNPAID_FIRST3 = 19,
    INVOICE_UNPAID_10K = 29,
}

/** The groups of the header dropdown. Mirrors the NotificationGroup enum of SpringCore. */
export enum NotificationGroupEnum {
    NEW = 'NEW',
    BLOCKED = 'BLOCKED',
    CAPPED = 'CAPPED',
    HOLIDAYS = 'HOLIDAYS',
    MAILING_PLANNINGS = 'MAILING_PLANNINGS',
}

/** The types whose extraInfo holds business type ids rather than an amount or free text. */
export const NOTIFICATION_TYPES_WITH_BUSINESS_TYPES: NotificationTypeEnum[] = [
    NotificationTypeEnum.NEW,
    NotificationTypeEnum.BLOCK,
    NotificationTypeEnum.MONTHLY_CAPPING,
    NotificationTypeEnum.CATEG_CAPPING,
    NotificationTypeEnum.CATEG_CAPPING_ZERO,
    NotificationTypeEnum.GLOBAL_CAPPING_ZERO,
    NotificationTypeEnum.HOLIDAYS_START,
    NotificationTypeEnum.HOLIDAYS_END,
];
